import { render, staticRenderFns } from "./BraceletHistory.vue?vue&type=template&id=b9d51f06&scoped=true"
import script from "./BraceletHistory.vue?vue&type=script&lang=js"
export * from "./BraceletHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d51f06",
  null
  
)

export default component.exports